<template>
	<div id="main" class="column is-9">
		<section class="my-statistics">
			<div class="columns">
				<div class="column">
					<div class="card">
						<header class="card-header">
						<p class="card-header-title">
							My Statistics
						</p>
						</header>
						<div v-for="(period, idx) in statistics" :key="idx">
							<div class="card-table">
								<div class="content">
									<div class="stats-holder">
										<div class="columns">
											<div class="column stats-header">
												<h5>{{  idx > 0 ? "Past" : "Current" }} Period</h5>
												<p class="an-date">
													{{ formatDate(period.fromDate) }} to {{ formatDate(period.toDate) }} 
												</p>
											</div>
										</div>
										<div class="columns">
											<div class="column is-6">
												<ul>
													<li><span>Current Rate</span>: {{ period.rate }}</li>
													<li><span>Revenue Per Call</span>: {{ period.rev_per_call }}</li>
													<li><span>Total Revenue</span>: {{ period.total_revenue }}</li>
													<li><span>Total Calls</span>: {{ period.all_calls }}</li>
													<li><span>Repeat Calls</span>: {{ period.rep_calls }}</li>
													<li><span>New Calls</span>: {{ period.new_calls }}</li>
													<li><span>Per-Min Calls</span>: {{ period.per_min_calls }}</li>
													<li><span>Total Minutes</span>: {{ period.tot_mins }}</li>
													<li><span>Repeat Minutes (Calls / Chats)</span>: {{ period.rep_call_mins }} / {{ period.rep_chat_mins }}</li>
													<li><span>New Call Minutes</span>: {{ period.new_call_mins }}</li>
													<li><span>Per-Min Call Minutes</span>: {{ period.per_min_call_mins }}</li>
													<li><span>New Chat Minutes</span>: {{ period.new_chat_mins }}</li>
													<li><span>Per-Min Chat Minutes</span>: {{ period.per_min_chat_mins }}</li>
												</ul>
											</div>
											<div class="column is-6">
												<ul>
													<li><span>ALC</span>: {{ period.alc }}</li>
													<li><span>Repeat Average (Calls / Chats)</span>: {{ period.rep_call_avg }} / {{ period.rep_chat_avg }}</li>
													<li><span>Per-Min Percent (Calls / Chats)</span>: {{ period.per_min_call_pct }} / {{ period.per_min_chat_pct }}</li>
													<li><span>Repeat Percent (Calls / Chats)</span>: {{ period.rep_call_pct }} / {{ period.rep_chat_pct }}</li>
													<li><span>New Average (Calls / Chats)</span>: {{ period.new_call_avg }} / {{ period.new_chat_avg }}</li>
													<li><span>Rating Count</span>: {{ period.rating_cng }}</li>
													<li><span>Rating Average</span>: {{ period.rating_avg }}</li>
													<li><span>Attempted</span>: {{ period.attempted }}</li>
													<li><span>Missed</span>: {{ period.total_missed }}</li>
													<li><span>Missed Percent</span>: {{ period.missed_pct }}</li>
													<li><span>Missed Reason</span>: {{ period.decl_vm_no_ans_busy }}</li>
													<li><span>Free Minutes</span>:  {{ period.free_psychic_mins }}</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
	import moment from "moment-timezone"
	export default {
		data() {
			return {
				user_id: null,
				statistics: []
			}
		},
		methods: {
			formatDate(date) {
				return moment.tz(date, moment.tz.guess(true)).format("MM/DD/YYYY hh:mm:ss A")
			}
		},
		async created() {
			this.user_id = JSON.parse(localStorage.getItem("user")).user_id
			let statistics = await this.$root.$data.getters.getStatistics(this.$root.$data.state, this.user_id)  
			for (let i = 0; i < statistics.length; i++) {
				this.statistics.push(statistics[i][0])
			}
		}
	}
</script>